export const ReportTypes = {
  MidTerm: "mid_term",
  EndOfOne: "end_of_semester_1",
  EndOfTwo: "end_of_semester_2"
};

export const ReportTemplates = {
  Default: "default",
  Standard: "standard",
  Honors: "honors",
  IgsPrep: "igs-prep",
  HighSchool: "high_school"
};

export const StatusReports = {
  Draft: "Draft",
  Pending: "Pending",
  Not_approve: "Not-approve",
  Official: "Official"
};

export const SubjectReports = {
  Review: "Review",
  Inputter: "Inputter",
  NoReview: "No-review"
};
